import { render, staticRenderFns } from "./SetupTab.vue?vue&type=template&id=8716cdd0&scoped=true&"
import script from "./SetupTab.vue?vue&type=script&lang=js&"
export * from "./SetupTab.vue?vue&type=script&lang=js&"
import style0 from "./SetupTab.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SetupTab.vue?vue&type=style&index=1&id=8716cdd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8716cdd0",
  null
  
)

export default component.exports